import { TournamentTypes } from "./types";

export const TOURNAMENT_TRANSLATE = {
  /** 錦標賽 */
  TITLE: "tournament.title",
  /** 查看詳情 */
  VIEW_DETAILS: "tournament.view_details",
  /** 進行中 */
  ONGOING: "tournament.ongoing",
  /** 即將開始 */
  COMING_SOON: "tournament.coming_soon",
  /** 已結束 */
  ENDED: "tournament.ended",
  /** 結束時間 */
  END_TIME: "tournament.end_time",
  /** 開始時間 */
  START_TIME: "tournament.start_time",
  /** 比賽總獎金 */
  TOTAL_PRIZE_POOL: "tournament.total_prize_pool",
  /** 比賽時間 */
  DURATION: "tournament.duration",
  /** 查看全部 */
  VIEW_ALL: "tournament.view_all",
  /** 收起 */
  COLLAPSE: "tournament.collapse",
  /** 更多賽事，敬請期待 */
  MORE_COMING_SOON: "tournament.more_coming_soon",
  /** 玩游戏赢取奖励 */
  PLAY_GAMES_TO_WIN_REWARDS: "tournament.play_games_to_win_rewards",
  /** 展示 {val1} / {val2} 个游戏 */
  DISPLAYING_GAMES: "home.displaying_games",
  /** 加载更多 */
  LOAD_MORE: "home.load_more",
} as const;

export const statusMapping = {
  [TournamentTypes.Ongoing]: TOURNAMENT_TRANSLATE.END_TIME,
  [TournamentTypes.Upcoming]: TOURNAMENT_TRANSLATE.START_TIME,
  [TournamentTypes.Ended]: TOURNAMENT_TRANSLATE.ENDED,
};

export const detailStatusMapping = {
  [TournamentTypes.Ongoing]: TOURNAMENT_TRANSLATE.END_TIME,
  [TournamentTypes.Upcoming]: TOURNAMENT_TRANSLATE.START_TIME,
  [TournamentTypes.Ended]: TOURNAMENT_TRANSLATE.ENDED,
};
